import { mapActions } from 'vuex';

export default {
  data() {
    return {
      rounds: [],
      roundsKey: 'rounds',
    };
  },
  created() {
    this.UPDATE_CONFIRM_MSG = this.$t(
      '_web_tournaments-tableview_update-confirm',
      'It takes some time to update further grid. Update it now?'
    );
    this.UPDATE_WARNING_MSG = this.$t(
      '_web_tournaments-tableview_update-warning',
      'It takes some time to update grid data. Update grid manually later, please'
    );
  },
  methods: {
    ...mapActions([
      'updateRoundAction',
      'startRoundAction',
      'finishRoundAction',
      'closeModal',
      'successNotify',
    ]),
    minRoundDatetime() {
      const now = Math.floor(Date.now() / 1000);
      return Math.max(now, this.currentTournamentStage.date_start);
      /*roundIndex === 0
        ? Math.max(now, this.currentTournamentStage.date_start)
        : Math.max(now, this.rounds[roundIndex - 1].date_end);*/
    },
    maxRoundDatetime() {
      /*const lastRoundIndex = this.rounds.length - 1;
      return roundIndex < lastRoundIndex &&
        this.rounds[roundIndex + 1].date_start
        ? this.rounds[roundIndex + 1].date_start
        : this.competitionConfig.tournament_end;*/
      return this.currentTournamentStage.date_end;
    },
    onRoundDateChanged(newDate, roundIndex) {
      const prevDate = this.rounds[roundIndex].date_start;
      if (newDate !== prevDate) {
        this.$set(this.rounds, roundIndex, {
          ...this.rounds[roundIndex],
          date_start: newDate,
        });

        return this.updateRoundAction({
          roundID: roundIndex,
          data: {
            date_start: newDate,
            grid: this.grid,
          },
        })
          .then(() => {
            this.successNotify({
              text: this.$t(
                '_web_tournament_match-date-changed',
                'Round start date changed. Further matches dates recalculated.'
              ),
            });
          })
          .then(() => this.fetchRoundsData(true))
          .then(() => {
            this.forceUpdate = true;
            return this.fetchMatchesData(roundIndex);
          })
          .catch(error => {
            this.updateRoundsKey();
            this.errorNotify(error);
            this.$set(this.rounds, roundIndex, {
              ...this.rounds[roundIndex],
              date_start: prevDate,
            });
          })
          .finally(() => {
            this.forceUpdate = false;
          });
      }
    },
    updateRoundsKey() {
      this.roundsKey = 'rounds' + Date.now();
    },
    startRound({ roundID, grid }) {
      this.closeModal();
      return this.startRoundAction({ roundID, grid })
        .then(() => {
          if (this.updateMatchesData) {
            return setTimeout(() => this.updateMatchesData(), 1000);
          }
        })
        .then(() => {
          this.successNotify({
            text: this.$t(
              '_web_tournament_round-started',
              'Round is successfully started'
            ),
          });
        })
        .catch(this.errorNotify);
    },
    finishRound({ roundID, grid }) {
      this.closeModal();
      return this.finishRoundAction({ roundID, grid })
        .then(() => {
          if (this.updateMatchesData) {
            return setTimeout(() => this.updateMatchesData(), 1000);
          }
        })
        .then(() => {
          this.successNotify({
            text: this.$t(
              '_web_tournament_round-finished',
              'Round is successfully finished'
            ),
          });
        })
        .catch(this.errorNotify);
    },
  },
};
